export type FeedbackPreferences={sounds:boolean;vibrations:boolean};
export const feedbackKey=(uid?:string)=>'khojipark-feedback:'+ (uid??'guest');
const memory=new Map<string,FeedbackPreferences>();
export function readFeedback(uid?:string):FeedbackPreferences{
 const key=feedbackKey(uid);if(memory.has(key))return memory.get(key)!;
 try{const value=JSON.parse(localStorage.getItem(key)??'null');return {sounds:value?.sounds!==false,vibrations:value?.vibrations!==false};}catch{return {sounds:true,vibrations:true};}
}
export function saveFeedback(value:FeedbackPreferences,uid?:string){
 const key=feedbackKey(uid);memory.set(key,value);
 try{localStorage.setItem(key,JSON.stringify(value));return true;}catch{return false;}
}
export function clearFeedback(uid?:string){memory.delete(feedbackKey(uid));try{localStorage.removeItem(feedbackKey(uid));}catch{/* Device storage is optional. */}}
let audio:AudioContext|undefined;
export function playReadingFeedback(uid?:string){
 const prefs=readFeedback(uid);
 if(prefs.vibrations&&typeof navigator.vibrate==='function')try{navigator.vibrate(12);}catch{/* Unsupported device. */}
 if(prefs.sounds&&typeof AudioContext!=='undefined')try{
  audio??=new AudioContext();const context=audio;
  void context.resume().then(()=>{const oscillator=context.createOscillator(),gain=context.createGain(),now=context.currentTime;oscillator.type='sine';oscillator.frequency.setValueAtTime(660,now);oscillator.frequency.exponentialRampToValueAtTime(880,now+.07);gain.gain.setValueAtTime(.025,now);gain.gain.exponentialRampToValueAtTime(.0001,now+.12);oscillator.connect(gain);gain.connect(context.destination);oscillator.start(now);oscillator.stop(now+.12);oscillator.onended=()=>{oscillator.disconnect();gain.disconnect();};}).catch(()=>{});
 }catch{/* Audio support is optional. */}
}
